import { ensureError } from '@sortera/ee-utils';
import { heicTo, isHeic as isHeicOriginal } from 'heic-to';
import { ERROR_NAME_HEIC_CONVERSION_FAILED, ERROR_NAME_HEIC_DETECTION_FAILED } from './constants.js';
export async function convertHeicToJpg(file, options) {
    try {
        options?.hooks?.onBeforeConversion?.(file);
        const blob = await heicTo({
            blob: file,
            type: 'image/jpeg',
            quality: 1,
        });
        const result = new File([blob], file.name.replace(/\.[^/.]+$/, '.jpg'), { type: 'image/jpeg' });
        options?.hooks?.onConversionSucceeded?.(result);
        return result;
    }
    catch (err) {
        const error = ensureError(err);
        error.name = ERROR_NAME_HEIC_CONVERSION_FAILED;
        options?.hooks?.onError?.(error, file);
        throw error;
    }
}
export async function isHeic(file, options) {
    try {
        return await isHeicOriginal(file);
    }
    catch (err) {
        const error = ensureError(err);
        error.name = ERROR_NAME_HEIC_DETECTION_FAILED;
        options?.hooks?.onError?.(error, file);
        throw error;
    }
}
